import { create } from "zustand";
import { Origin, Scenario, Workspace } from "@models/ISchema";

type State = {
  workspaces: Workspace[];
  scenarios: Scenario[];
  origins: Origin[];
  isLoading: boolean;
};

export const useContextualizadorStore = create<State>(() => ({
  workspaces: [],
  scenarios: [],
  origins: [],
  isLoading: false,
}));

export const setContextualizadorData = ({
  workspaces,
  scenarios,
  origins,
}: {
  workspaces: Workspace[];
  scenarios: Scenario[];
  origins: Origin[];
}) => {
  useContextualizadorStore.setState({
    workspaces,
    scenarios,
    origins,
  });
};

export const setIsLoadingContextualizador = (isLoading: boolean) => {
  useContextualizadorStore.setState({ isLoading });
};
